/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
//added for the fix of view reccuring defect
import './authAndSubmit.js';

window.sbBehaviours = window.sbBehaviours || {};
sbBehaviours.contactPayment = {
  properties: {
    submitObject: {
      type: Object,
      notify: true
    }
  },
  setPostDataAndPostRequest: function () {
    let primaryMaxAmt = 0;
    let selectiveMaxAmt = 0;
	if(this.selectedAccount){
		for (let i = 0; i < this.selectedAccount.balances.length; i++) {
		  if (this.selectedAccount.balances[i].type === "availableBalance") {
			primaryMaxAmt = this.selectedAccount.balances[i].amountDetails.amount;
			break;
		  }
		}
	}
    if (this.contactAmount > primaryMaxAmt) {
      this.selectedAccount = this.fromAccountSelector._returnPrimaryAccount(this.contactAmount);
      for (let i = 0; i < this.selectedAccount.balances.length; i++) {
        if (this.selectedAccount.balances[i].type === "availableBalance") {
          selectiveMaxAmt = this.selectedAccount.balances[i].amountDetails.amount;
          break;
        }
      }

      if (this.contactAmount > selectiveMaxAmt && setBusinessDateString(formatOEDateBusiness(this.recurringDate)) == setBusinessDateString(getNewDate().toISOString().slice(0, 19))) {
        this.fire('oe-show-error', getLabel("l_BalanceCheck"));
        this.loaderActive = false;
        return;
      }
    }

    var postData = {};
    var transactionType;
    var counterpartybankcode = this.counterparty ? this.counterparty.bankType ? this.counterparty.bankType.cmCode : "" : "";
    var transactionCurrency = typeof this.transactionCurrency === "object" ? this.transactionCurrency.cmCode : this.transactionCurrency;
    if (counterpartybankcode === "OBK") transactionType = "PPO"; else if (counterpartybankcode === "HBK") transactionType = "PPW"; else transactionType = "PMT";

    postData = {
      "transactionReferenceName": "",
      "transactionDate": this.showSchedule == true ? setBusinessDateString(formatOEDateBusiness(this.recurringDate)) : setBusinessDateString(getNewDate()),//.toISOString().slice(0, 19)),
      "transactionCurrency": transactionCurrency,
      "transactionType": transactionType,
      "frequencyType": this.recurringCheckbox == true ? this.recurringCodeListSelectedItem.cmCode != 0 ? "R" : "O" : "O",
      "manualReleaseRequired": "N"
    };

    postData.recurringDetails = this.recurringCheckbox == true ? {
      "validityIndicator": "N",
      "recurringFrequency": this.recurringCodeListSelectedItem.cmCode,
      "numberOfInstallments": this.recurringCodeListSelectedItem.cmCode > 0 ? this.numberOfInstallments : "",
      "frequencyInDays": this.recurringCodeListSelectedItem.cmCode == 8 ? this.numberOfDays : ""
    } : {
        "validityIndicator": "N"
      };

    if (this.counterparty.counterpartyType || this.counterparty.partyType) {
      if(!this.counterparty.counterpartyType){
        this.counterparty.counterpartyType = this.counterparty.partyType;
      }
      if (this.counterparty.counterpartyType.cmCode == "NN") {
        postData.entryDetails = [

          {
            "entryID": "0",
            "initiatorAccount": this.selectedAccount.accountId,
            "markAsDelete": "",
            "payeeAccountDetails": {
              "counterpartyAccount": this.counterparty.payeeListId
            },
            "amount": this.contactAmount,
            "counterpartyType": "P",
            "network": "",
            "remarks": this.contactRemarks,
            "payeeReference": "",
            "transactionPurpose": ""
          }

        ]
      }
      else if (this.counterparty.counterpartyType.cmCode == "PP") {
        postData.transactionType = "PPP"
        postData.entryDetails = [
          {
            "entryID": "0",
            "initiatorAccount": this.selectedAccount.accountId,
            "markAsDelete": "",
            "payeeAccountDetails": {
              "counterpartyAccount": this.counterparty.payeeListId
            },
            "amount": this.contactAmount,
            "counterpartyType": "J",
            "network": "",
            "remarks": this.contactRemarks,
            "payeeReference": "",
            "transactionPurpose": ""
          }
        ]
      }
    }
    else if (this.counterparty.entryDetails[0].counterpartyType) {
      if (this.counterparty.entryDetails[0].counterpartyType == "J") {
        postData.transactionType = "PPP";
      }
      postData.entryDetails = [{
        "entryID": "0",
        "initiatorAccount": this.selectedAccount.accountId,
        "markAsDelete": "",
        "payeeAccountDetails": {
          "counterpartyAccount": this.counterparty.entryDetails[0].payeeAccountDetails.counterpartyAccount
        },
        "amount": this.contactAmount,
        "counterpartyType": this.counterparty.entryDetails[0].counterpartyType,
        "network": "",
        "remarks": this.contactRemarks,
        "payeeReference": "",
        "transactionPurpose": ""
      }];
    }

    this.payContactObject = postData;
    this.submitContactPayment();

  },
  submitContactPayment: function () {
    if (this.authMethods == undefined || this.authMethods && this.authMethods.length == 0) {
      this.authMethods = [];
      this.header = [];
    } else {
      if (this.authenticationValidation(this.authMethods)) return;
      if (this.authMethods && this.authMethods.length == 1) this.header.primaryAccessCode = this.authMethods[0].wrapperValue;

      if (this.authMethods && this.authMethods.length == 2) {
        this.header.primaryAccessCode = this.authMethods[0].wrapperValue;
        this.header.secondaryAccessCode = this.authMethods[1].wrapperValue;
      }
    }
    var url, method;
    if (this.type == "SCH") {
      this.payContactObject.entryDetails[0].entryID = 1;
    
      url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/multientrytransactionsrequests/' + this.scheduledId;
      method = 'put';
    } else {
      url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/multientrytransactionsrequests';
      method = 'post';
    }

    this.submitDetails(url, method, this.payContactObject, this.header);
  },
  setAliasPostDataAndPostRequest: function () {
    let primaryMaxAmt = 0;
    let selectiveMaxAmt = 0;

    for (let i = 0; i < this.selectedAccount.balances.length; i++) {
      if (this.selectedAccount.balances[i].type === "availableBalance") {
        primaryMaxAmt = this.selectedAccount.balances[i].amountDetails.amount;
        break;
      }
    }

    if (this.adhocAmount > primaryMaxAmt) {
      this.selectedAccount = this.fromAccountSelector._returnPrimaryAccount(this.adhocAmount);

      for (let i = 0; i < this.selectedAccount.balances.length; i++) {
        if (this.selectedAccount.balances[i].type === "availableBalance") {
          selectiveMaxAmt = this.selectedAccount.balances[i].amountDetails.amount;
          break;
        }
      }

      if (this.adhocAmount > selectiveMaxAmt && setBusinessDateString(formatOEDateBusiness(this.recurringDate)) == setBusinessDateString(getNewDate().toISOString().slice(0, 19))) {
        this.fire('oe-show-error', getLabel("l_BalanceCheck"));
        this.loaderActive = false;
        return;
      }
    }

    if (this.selectedPaymentType == "ALS") {
      this.recurringDetails = this.recurringCheckbox == true ? {
        "validityIndicator": "N",
        "recurringFrequency": this.recurringCodeListSelectedItem.cmCode,
        "numberOfInstallments": this.recurringCodeListSelectedItem.cmCode > 0 ? this.numberOfInstallments : "",
        "frequencyInDays": this.recurringCodeListSelectedItem.cmCode == 8 ? this.numberOfDays : ""
      } : {
          "validityIndicator": "N"
        };
      this.submitObject = {
        "transactionReferenceName": "txnreference",
        "transactionDate": this.showSchedule == true ? setBusinessDateString(formatOEDateBusiness(this.recurringDate)) : setBusinessDateString(getNewDate().toISOString().slice(0, 19)),
        "transactionCurrency": this.transactionCurrency,
        "transactionType": "PPP",
        "frequencyType": this.recurringCheckbox == true ? this.recurringCodeListSelectedItem.cmCode != 0 ? "R" : "O" : "O",
        "recurringDetails": this.recurringDetails,
        "manualReleaseRequired": "N",
        "entryDetails": [{
          "entryID": "0",
          "initiatorAccount": this.selectedFromAccount.accountId,
          //"EBSB1",
          "markAsDelete": "N",
          "payeeAccountDetails": {
            "adhocPayeeDetails": {
              "payeeName": this.selectedFromAccount.accountName,
              //"adhocaliaspayeename",
              "payeeNickName": this.selectedFromAccount.accountNickName,
              //"adhocaliaspayeenickname",
              "aliasDetails": {
                "alias": this.aliasId,
                "aliasType": this.aliasIdType
              },
              "saveToPersonalPayee": "N"
            }
          },
          "amount": this.adhocAmount,
          "counterpartyType": "Q",
          "network": "",
          "remarks": this.transactionRemarks,
          "payeeReference": "payeeReference",
          "transactionPurpose": ""
        }]
      };
    }

    if (this.selectedPaymentType == "WIB" || this.selectedPaymentType == "OTH") {
      if (this.selectedPaymentType === "WIB") {
        this.networkType = "WIB";
        this.payeeBank = "HBK";
        this.routeNum = config.SpeedBoat.App.SameBankRoutingNumber; // this.counterpartyBank = "HBK";
      } else {
        /*if bank network code is available, then bank network code is displayed else NFT */
        this.networkType = this.contactOthBankNwk? this.contactOthBankNwk : "NFT";
        this.routeNum = this.contactBankCode; // this.counterpartyBank = "OBK";
        this.payeeBank = "OBK";
      }

      var transactionType;
      var counterpartybankcode = this.counterparty ? this.counterparty.bankType ? this.counterparty.bankType.cmCode : "" : "";
      if (counterpartybankcode === "OBK") transactionType = "PPO"; else if (counterpartybankcode === "HBK") transactionType = "PPW"; else transactionType = "PMT";
      this.recurringDetails = this.recurringCheckbox == true ? {
        "validityIndicator": "N",
        "recurringFrequency": this.recurringCodeListSelectedItem.cmCode,
        "numberOfInstallments": this.recurringCodeListSelectedItem.cmCode > 0 ? this.numberOfInstallments : "",
        "frequencyInDays": this.recurringCodeListSelectedItem.cmCode == 8 ? this.numberOfDays : ""
      } : {
          "validityIndicator": "N"
        };

      this.submitObject = {
        "transactionReferenceName": "",
        "transactionDate": this.showSchedule == true ? setBusinessDateString(formatOEDateBusiness(this.recurringDate)) : setBusinessDateString(getNewDate().toISOString().slice(0, 19)),
        "transactionCurrency": this.transactionCurrency,
        "transactionType": transactionType,
        "frequencyType": this.recurringCheckbox == true ? this.recurringCodeListSelectedItem.cmCode != 0 ? "R" : "O" : "O",
        "manualReleaseRequired": "N",
        "recurringDetails": this.recurringDetails,
        "entryDetails": [{
          "entryID": "0",
          "initiatorAccount": this.selectedFromAccount.accountId,
          //"EBSB1",
          "markAsDelete": "",
          "payeeAccountDetails": {
            "counterpartyAccount": this.accountNum,
            "adhocPayeeDetails": {
              "payeeName": this.contactName,
              "payeeNickName": this.selectedFromAccount.accountNickName,
              "accountNumber": this.accountNum,
              "accountIdentifier": "A",
              "payeeAccountType": this.selectedFromAccount.accountType.cmCode,
              "accountCurrency": this.selectedFromAccount.accountCurrency.cmCode,
              "payeeBank": this.payeeBank,
              "payeeNetwork": this.networkType,
              "payeeBankIdentifier": this.routeNum,
              "saveToPersonalPayee": "N"
            }
          },
          "amount": this.adhocAmount,
          "counterpartyType": "H",
          "network": this.networkType,
          "remarks": this.transactionRemarks,
          "payeeReference": "",
          "transactionPurpose": ""
        }]
      };

    }


    this.payContactObject = this.submitObject;
    this.submitContactPayment();

  }


};